'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var statusPillVariantStyles = {
    rounded: styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    border-radius: 18px;\n  "], ["\n    border-radius: 18px;\n  "]))),
    squared: styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    border-radius: 5px;\n  "], ["\n    border-radius: 5px;\n  "]))),
};
var getColor = function (status, color, variant) {
    switch (status) {
        case constants.PROVIDERS_STATUSES.OPEN:
        case constants.PROVIDERS_STATUSES.POSITIVE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.admin.green;
            };
        case constants.PROVIDERS_STATUSES.CLOSED:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return (variant === constants.STATUS_PILL_VARIANT.ROUNDED ? theme.colors.greys.adminGreyDark : theme.colors.admin.pink);
            };
        case constants.PROVIDERS_STATUSES.NEGATIVE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.admin.pink;
            };
        case constants.PROVIDERS_STATUSES.CLOSING_SOON:
        case constants.PROVIDERS_STATUSES.PENDING:
        case constants.PROVIDERS_STATUSES.NOTICE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.admin.orange;
            };
        case constants.PROVIDERS_STATUSES.INFORMATIVE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.greys.adminGreyDark;
            };
        default:
            return color;
    }
};
var getBackgroundColor = function (status, color, variant) {
    switch (status) {
        case constants.PROVIDERS_STATUSES.OPEN:
        case constants.PROVIDERS_STATUSES.POSITIVE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.admin.lightGreen;
            };
        case constants.PROVIDERS_STATUSES.CLOSED:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return (variant === constants.STATUS_PILL_VARIANT.ROUNDED ? theme.colors.greys.adminGreyLight : theme.colors.admin.lightPink);
            };
        case constants.PROVIDERS_STATUSES.NEGATIVE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.admin.lightPink;
            };
        case constants.PROVIDERS_STATUSES.CLOSING_SOON:
        case constants.PROVIDERS_STATUSES.PENDING:
        case constants.PROVIDERS_STATUSES.NOTICE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.admin.lightOrange;
            };
        case constants.PROVIDERS_STATUSES.INFORMATIVE:
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return function (_a) {
                var theme = _a.theme;
                return theme.colors.greys.adminGreyLight;
            };
        default:
            return color + "26";
    }
};
var Container = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledStatusPill = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 13px/15px ", ";\n  padding: 5px 10px;\n  color: ", ";\n  background-color: ", ";\n  font-weight: 500;\n  ", ";\n"], ["\n  font: 13px/15px ", ";\n  padding: 5px 10px;\n  color: ", ";\n  background-color: ", ";\n  font-weight: 500;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var status = _a.status, color = _a.color, variant = _a.variant;
    return getColor(status, color, variant);
}, function (_a) {
    var status = _a.status, color = _a.color, variant = _a.variant;
    return getBackgroundColor(status, color, variant);
}, function (_a) {
    var variant = _a.variant;
    return statusPillVariantStyles[variant];
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.Container = Container;
exports.StyledStatusPill = StyledStatusPill;
